import React from 'react';
import config from '../../utils/config.js';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { getTemplates, displayMore } from '../../utils/apputils';
import { chunk } from '../../utils/utilities';
import { users } from '../../store/actions';
import Spinner from '../Spinner/Spinner.js';
import { productView } from '../../utils/google';
import { omit } from 'lodash';

const Home = () => (
  <div>
    <HomeHero />
    <HomeBody />
  </div>
);

const HomeHero_Class = ({ collections }) => (
  <div>
    <div className="banner">
      <div className="container">
        <img
          src="/marketing-image.png"
          className="img-fluid"
          alt="Professional looking mockups made diabolically easy"
        />
      </div>
    </div>

    <nav className="collections-nav">
      <div className="container">
        <h2 className="collections-nav-title">Browse collections:</h2>
        <ul>
          {collections.map(collection => {
            const { name } = collection;
            return (
              <li key={name} className="collections-nav-item">
                <Link to={'/collection/' + name}>{name}</Link>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  </div>
);

const PreviewCard = ({ per_row, angle, name, image, description }) => (
  <Col xs={12 / per_row}>
    <LinkContainer
      className="card"
      to={'/feature/' + image}
      style={{ transform: `rotate(${angle}deg)` }}
      onClick={() => productView(image)}
    >
      <div>
        <h3 className="card-title">{name}</h3>
        <div className="card-img">
          <img
            src={`https://s3.${config.region}.amazonaws.com/${
              config.TemplateBucket
            }/${image}_thumbnail`}
            className="home-thumbnail"
            width="310"
            alt=""
          />
        </div>
        <p className="card-desc">{description}</p>
        <Button className="card-cta btn btn-bevel">Personalise it now!</Button>
      </div>
    </LinkContainer>
  </Col>
);

class ImageGrid_Class extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    getTemplates(dispatch);
  }
  render() {
    const { width, imageCount, templateData } = this.props;
    const listicle = templateData
      .slice(0, imageCount)
      .map((template, index) => {
        const { name, key, description } = template;
        const angle = Math.floor(Math.random() * (11 - 5) + 5);
        return (
          <PreviewCard
            name={name}
            description={description}
            key={key}
            image={key}
            per_row={width}
            angle={`${'+-'[index % 2]}${angle}`}
          />
        );
      });
    return chunk(listicle, width).map((part, index) => (
      <Row key={index}>{part}</Row>
    ));
  }
}

const mapStateToProps = state => ({
  templates: state.s3Templates.templatesJSON.templates,
  collections: state.s3Templates.templatesJSON.collections,
  imageCount: state.users.homeDisplayCount,
  displayCountStatus: state.users.displayCountStatus
});

export const ImageGrid = connect()(ImageGrid_Class);
const HomeHero = connect(mapStateToProps)(HomeHero_Class);

class HomeBody_Class extends React.Component {
  displayMore = () => {
    const { dispatch } = this.props;
    displayMore(dispatch, 'homeMoreButton');
  };

  render() {
    // Converting the state object keyed against UUID to an array of objects we can
    // iterate over with the image key as a prop
    const {
      templates,
      collections,
      imageCount,
      displayCountStatus
    } = this.props;
    const miscCollection = collections.find(x => x.name === 'Misc');
    const miscTemplatesKeys = miscCollection ? miscCollection.templates : [];
    const templatesMiscOmitted = omit(templates, miscTemplatesKeys);
    const templateKeys = Object.keys(templatesMiscOmitted);
    const templateValues = Object.values(templatesMiscOmitted);
    const templateData = templateValues.map((valueObject, index) => {
      return { ...valueObject, key: templateKeys[index] };
    });
    return (
      <Grid>
        <ImageGrid
          width={3}
          templateData={templateData}
          imageCount={imageCount}
        />
        <div className="pagination">
          <button
            id="home-more-button"
            className="btn btn-secondary btn-bevel"
            onClick={this.displayMore}
            disabled={templateData.length <= imageCount}
          >
            {displayCountStatus !== users.types.DISPLAYING_MORE && (
              <span>More</span>
            )}
            {displayCountStatus === users.types.DISPLAYING_MORE && (
              <Spinner type="moreButton" />
            )}
          </button>
        </div>
      </Grid>
    );
  }
}

const HomeBody = connect(mapStateToProps)(HomeBody_Class);

export default Home;



// WEBPACK FOOTER //
// ./src/comps/Home/Home.js